import './styles/ui.scss';
import './styles/index.scss';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import '@/views/authox/styles/authox.scss';
import 'reflect-metadata';
import '@suc/chain';
import Vue from 'vue';
import App from './App.vue';
import { install, createApp, h } from 'vue-demi';
import { pinia } from './stores';
import router from './router';
import plugin from './utils/plugin';
import { useInterceptors } from './utils/useInterceptors';
import http from './utils/http';
import funcs from '@/utils/funcs';
import { prepareApp } from '@/utils/prepareApp';
import '@/utils/element'
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import '@/assets/iconfont/iconfont.css'
import authox from "@/views/authox/plugins/authox-vue";
Vue.config.productionTip = false;

useInterceptors(http, router);

//composition必须是第一个use
install();
Vue.use(VXETable);
Vue.use(plugin);
Vue.use(funcs);
Vue.use(authox,pinia);
async function main() {
    await prepareApp();
    createApp({
        pinia,
        router,
        render: () => h(App),
    }).mount('#app');
}

main().catch(console.error);
